import { Fragment } from "react";

/*
 * This function takes a string and splits it on string "<br/>".
 * It then maps over the array of strings and returns a Fragment with the string and an
 * actual <br/> tag.
 *
 * This enables us to support line breaks without using dangerouslySetInnerHTML.
 *
 */
export const enableBrTags = (title?: string) => {
    const titles = title?.split("<br/>");
    return titles?.map((title, index) => {
        return getElementWithBrTag(title, index);
    });
};

const getElementWithBrTag = (title: string, index: number) => {
    return (
        <Fragment key={index}>
            {title} <br />
        </Fragment>
    );
};

export const replaceDatePlaceholders = (text: string): string => {
    const now = new Date();
    const monthShort = now.toLocaleString('default', { month: 'short' });
    const monthLong = now.toLocaleString('default', { month: 'long' });
    const yearShort = now.getFullYear().toString().slice(-2);
    const yearLong = now.getFullYear().toString();

    return text.replace(/{{MM}}/gi, monthShort)
              .replace(/{{MMMM}}/gi, monthLong)
              .replace(/{{YY}}/gi, yearShort)
              .replace(/{{YYYY}}/gi, yearLong);
};
